var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue } from 'vue-property-decorator';
import _ from 'lodash';
import PtIcon from '@patsnap-biz/icon';
import Popover from 'element-ui/lib/popover';
import { FieldTabType, fieldPtIconMappings, fieldColorList } from './fieldManager';
import PtCheckbox from './Checkbox.vue';
import DraggableList from 'vuedraggable';
import FieldInfoPopover from './FieldInfoPopover.vue';
import locales from '../locales';
import '@patsnap-ui/icon/assets/solid/TextSurround.svg';
import '@patsnap-ui/icon/assets/solid/OneTwoThree.svg';
import '@patsnap-ui/icon/assets/solid/Calendar7.svg';
import '@patsnap-ui/icon/assets/solid/CheckboxOnOutline.svg';
import '@patsnap-ui/icon/assets/solid/Url.svg';
import '@patsnap-ui/icon/assets/solid/TreeHorizontal.svg';
import '@patsnap-ui/icon/assets/solid/move.svg';
import '@patsnap-ui/icon/assets/solid/delete.svg';
import '@patsnap-ui/icon/assets/solid/SearchLeft.svg';
import '@patsnap-ui/icon/assets/solid/CloseBig.svg';
import '@patsnap-ui/icon/assets/solid/NoDataTip.svg';
import '@patsnap-ui/icon/assets/solid/info.svg';
import '@patsnap-ui/icon/assets/solid/PatsnapAi.svg';
import '@patsnap-ui/icon/assets/solid/AIField.svg';
import Tooltip from 'element-ui/lib/tooltip';
const FIELD_HIGHT_EXP = /[-\/\\^$*+?.()|[\]{}]/g;
// @ts-ignore
let FieldListPane = class FieldListPane extends Vue {
    constructor() {
        super(...arguments);
        this.fieldPtIconMappings = fieldPtIconMappings;
        this.FieldTabType = FieldTabType;
        this.currentTab = FieldTabType.STANDARD;
        this.filter = '';
        this.optionOrLayerFieldInfoPromiseCache = {};
        this.isDraging = false;
    }
    get currentTabListFiltered() {
        return _.filter(this.currentTabList, (key) => {
            if (!this.filter)
                return true;
            const { displayName = '' } = this.getFieldItem(key);
            const _display_name = displayName.toLowerCase();
            const _filter = this.filter.toLowerCase();
            return _display_name.includes(_filter);
        });
    }
    get noDataText() {
        return this.filter ? this.$t('PtFieldManagerPanel.searchNoData') : this.$t('PtFieldManagerPanel.noData');
    }
    get currentTabList() {
        return this.currentTab === FieldTabType.STANDARD
            ? this.standardFieldKeyList
            : this.customFieldKeyList;
    }
    get standardFieldKeyList() {
        return _.filter(this.fieldKeyList, key => !this.getFieldItem(key).fieldType);
    }
    get customFieldKeyList() {
        return _.filter(this.fieldKeyList, key => !!this.getFieldItem(key).fieldType);
    }
    isChecked(key) {
        return this.visibleFieldKeyList.includes(key);
    }
    getFieldItem(key) {
        return this.fieldMap[key] || {};
    }
    getIsNewField(key) {
        return _.includes(this.newFieldKeyList, key);
    }
    getIsPatsnapAiField(key) {
        return _.includes(this.patsnapAiFieldKeyList, key);
    }
    getFieldIcon(key) {
        return fieldPtIconMappings[this.getFieldItem(key).fieldType];
    }
    getFieldColor(key) {
        const { fieldColor } = this.getFieldItem(key);
        return fieldColorList[fieldColor || 0];
    }
    getFieldLabelScope(key) {
        const { fieldLabelScope } = this.getFieldItem(key);
        return fieldLabelScope || 'USER';
    }
    getFieldLabelScopeIsSpace(key) {
        return this.getFieldLabelScope(key) === 'SPACE';
    }
    getFieldHighlightDisplayName(key) {
        const { displayName = '' } = this.getFieldItem(key);
        if (!this.filter)
            return displayName;
        const _filter = this.filter.toLowerCase().replace(FIELD_HIGHT_EXP, '\\$&');
        return displayName.replace(new RegExp(_filter, 'ig'), i => `<span class="heighlight-field-name">${i}</span>`);
    }
    clickField(key) {
        if (this.isToggleVisibleDisabled(key, this.getFieldItem(key), this.fieldMap)) {
            return;
        }
        this.$emit(this.isChecked(key) ? 'hideField' : 'visibleField', key, this.getFieldItem(key), this.fieldMap);
    }
    updateFieldSort({ moved }) {
        if (moved) {
            this.$emit('updateFieldSort', moved);
        }
        else {
            console.error('No Moved Info');
        }
    }
    setCurrentTab(tab) {
        if (tab === this.currentTab)
            return;
        this.filter = '';
        this.currentTab = tab;
    }
    getOptionOrLayerFieldInfoPromiseCacheFn(key) {
        const cache = this.optionOrLayerFieldInfoPromiseCache[key];
        if (cache) {
            return Promise.resolve(cache);
        }
        return this.getOptionOrLayerFieldInfoPromise(key).then((res) => {
            this.optionOrLayerFieldInfoPromiseCache[key] = res;
            return res;
        });
    }
    onDragStart() {
        this.isDraging = true;
    }
    onDragEnd() {
        this.isDraging = false;
    }
};
__decorate([
    Prop({ type: Array, default: () => [] })
], FieldListPane.prototype, "fieldKeyList", void 0);
__decorate([
    Prop({ type: Object, default: () => ({}) })
], FieldListPane.prototype, "fieldMap", void 0);
__decorate([
    Prop({ type: Array, default: () => [] })
], FieldListPane.prototype, "visibleFieldKeyList", void 0);
__decorate([
    Prop({ type: Array, default: () => [] })
], FieldListPane.prototype, "newFieldKeyList", void 0);
__decorate([
    Prop({ type: Array, default: () => [] })
], FieldListPane.prototype, "patsnapAiFieldKeyList", void 0);
__decorate([
    Prop({ type: Function, default: () => false })
], FieldListPane.prototype, "isToggleVisibleDisabled", void 0);
__decorate([
    Prop({ type: Function, default: () => false })
], FieldListPane.prototype, "isSortDisabled", void 0);
__decorate([
    Prop({ type: Function, default: () => false })
], FieldListPane.prototype, "isSortIconVisible", void 0);
__decorate([
    Prop({ type: Function, })
], FieldListPane.prototype, "getOptionOrLayerFieldInfoPromise", void 0);
__decorate([
    Prop({ type: String, default: '' })
], FieldListPane.prototype, "spaceScopeFieldTip", void 0);
FieldListPane = __decorate([
    Component({
        name: 'FieldListPane',
        components: {
            PtCheckbox,
            PtIcon,
            DraggableList,
            FieldInfoPopover,
            ElPopover: Popover,
            ElTooltip: Tooltip,
        },
        i18n: {
            fallbackLocale: 'cn',
            messages: locales,
        },
    })
], FieldListPane);
export default FieldListPane;
